var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"social-quick-link"},[_c('div',{staticClass:"whats-app"},[_c('a',{attrs:{"href":`https://`+_vm.platform+`.whatsapp.com/send?phone=60109099928`,"target":"_blank"}},[_c('fa-icon',{staticClass:"icon",attrs:{"icon":['fab', 'whatsapp'],"color":"white"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }